export default __webpack_public_path__ + "static/media/cover2.9fdce53f.jpg";